import React from 'react';
import { CalendarIcon, SunIcon, MoonIcon, ZapIcon } from 'lucide-react';
import { ProtocolCard } from '../ui/ProtocolCard';
export const DailyProtocols: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-464">
      <div className="mb-6" data-id="element-465">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-466">
          Daily Longevity Protocols
        </h1>
        <p className="text-gray-600" data-id="element-467">
          Dein personalisierter Tagesplan für optimale Gesundheit
        </p>
      </div>
      {/* Today's Protocol */}
      <section className="mb-8" data-id="element-468">
        <div className="flex items-center mb-4" data-id="element-469">
          <CalendarIcon size={20} className="text-purple-600 mr-2" data-id="element-470" />
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-471">
            Heute: Regenerationstag
          </h2>
        </div>
        <ProtocolCard title="Regenerationstag" description="Dein Schlaf war letzte Nacht nicht optimal. Fokussiere dich heute auf Regeneration." progress={30} tasks={[{
        title: 'Morgen-Meditation (10 Min.)',
        completed: true
      }, {
        title: 'Magnesium-Supplement (300mg)',
        completed: false
      }, {
        title: 'Leichte Bewegung (20 Min.)',
        completed: false
      }, {
        title: 'Früh schlafen gehen (22:00)',
        completed: false
      }]} data-id="element-472" />
      </section>
      {/* Protocol Types */}
      <section className="mb-8" data-id="element-473">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-474">
          Deine Protokoll-Typen
        </h2>
        <div className="space-y-4" data-id="element-475">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-476">
            <div className="flex items-center mb-3" data-id="element-477">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-478">
                <MoonIcon size={20} className="text-blue-600" data-id="element-479" />
              </div>
              <div className="flex-1" data-id="element-480">
                <p className="font-medium text-gray-800" data-id="element-481">Regenerationstag</p>
                <p className="text-sm text-gray-500" data-id="element-482">
                  Bei Schlafmangel oder hohem Stress
                </p>
              </div>
              <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full" data-id="element-483">
                Heute aktiv
              </span>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-484">
              Fokus auf Erholung, Stressreduktion und Regeneration. Enthält
              beruhigende Übungen und Supplements.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-485">
            <div className="flex items-center mb-3" data-id="element-486">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center mr-3" data-id="element-487">
                <SunIcon size={20} className="text-yellow-600" data-id="element-488" />
              </div>
              <div data-id="element-489">
                <p className="font-medium text-gray-800" data-id="element-490">
                  Zellstimulierungs-Tag
                </p>
                <p className="text-sm text-gray-500" data-id="element-491">Bei optimalen Werten</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-492">
              Maximiere deine Leistungsfähigkeit mit Kältetherapie,
              Intervallfasten und gezielten Supplements.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-493">
            <div className="flex items-center mb-3" data-id="element-494">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-495">
                <ZapIcon size={20} className="text-green-600" data-id="element-496" />
              </div>
              <div data-id="element-497">
                <p className="font-medium text-gray-800" data-id="element-498">
                  Metabolischer Aktionstag
                </p>
                <p className="text-sm text-gray-500" data-id="element-499">Bei Bewegungsmangel</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-500">
              Aktiviere deinen Stoffwechsel mit gezielten Bewegungseinheiten und
              metabolisch aktiven Nahrungsmitteln.
            </p>
          </div>
        </div>
      </section>
      {/* Upcoming Protocols */}
      <section data-id="element-501">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-502">
          Kommende Protokolle
        </h2>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-503">
          <div className="p-4 border-b border-gray-100" data-id="element-504">
            <div className="flex items-center" data-id="element-505">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center mr-3" data-id="element-506">
                <SunIcon size={20} className="text-yellow-600" data-id="element-507" />
              </div>
              <div data-id="element-508">
                <p className="font-medium text-gray-800" data-id="element-509">
                  Zellstimulierungs-Tag
                </p>
                <p className="text-sm text-gray-500" data-id="element-510">
                  Morgen, basierend auf aktueller Prognose
                </p>
              </div>
            </div>
          </div>
          <div className="p-4 border-b border-gray-100" data-id="element-511">
            <div className="flex items-center" data-id="element-512">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-513">
                <ZapIcon size={20} className="text-green-600" data-id="element-514" />
              </div>
              <div data-id="element-515">
                <p className="font-medium text-gray-800" data-id="element-516">
                  Metabolischer Aktionstag
                </p>
                <p className="text-sm text-gray-500" data-id="element-517">
                  Übermorgen, vorläufige Prognose
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};